<template>
	<div class="panel">
		<div class="container">
			<div class="panel_header mb-4">
				<h2>Московская школа управления Сколково</h2>
			</div>
			<div class="row">
				<div class="col-12 col-md-6">
					<ul class="list-unstyled properties-list">
						<li class="title">
							<a class="icon-phone" href="tel:+74955393003">+7 495 539 30 03</a>
						</li>
						<li class="title">
							<a class="icon-mail" href="mailto:info@skolkovo.ru">info@skolkovo.ru</a>
						</li>
						<li class="title">
							<a class="icon-www" href="https://www.skolkovo.ru">www.skolkovo.ru</a>
						</li>
					</ul>
				</div>

				<div class="col-12 col-md-6">
					<ul class="list-unstyled properties-list">
						<li class="title">
							<span class="icon-place">143026, Московская область, город Одинцово, деревня Сколково, улица Новая, дом 100</span>
						</li>
					</ul>
					<a
						target="_blank"
						href="https://www.google.com/maps/search/%D0%9C%D0%A8%D0%A3+%D0%A1%D0%9A%D0%9E%D0%9B%D0%9A%D0%9E%D0%92%D0%9E+%D0%9D%D0%BE%D0%B2%D0%B0%D1%8F,+%D0%B4.100,+%D0%A1%D0%BA%D0%BE%D0%BB%D0%BA%D0%BE%D0%B2%D0%BE,+%D0%9C%D0%BE%D1%81%D0%BA%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F+%D0%BE%D0%B1%D0%BB.,+143025/@55.6948742,37.3877546,17z?hl=ru-RU"
						class="btn btn-outline-primary"
					>Посмотреть на карте</a>
				</div>
			</div>

			<hr class="my-5">

			<div class="row">
				<div class="col-12 col-md-6">
					<div class="title mb-3">
						Отдел по организации коммерческих мероприятий на территории бизнес-школы Сколково
					</div>

					<ul class="list-unstyled properties-list">
						<li><a class="icon-phone" href="tel:+7 495 539 30 03">+7 495 539 30 03</a></li>
						<li><a class="icon-mail" href="mailto:event_sales@skolkovo.ru">event_sales@skolkovo.ru</a></li>
					</ul>
				</div>

				<div class="col-12 col-md-6">
					<div class="title mb-3">
						Гостиничный комплекс Московской школы управления СКОЛКОВО
					</div>
					<div class="row">
						<div class="col-12 col-md-4">
							<strong>Ресепшн</strong>
						</div>
						<div class="col-12 col-md-8">
							<ul class="list-unstyled properties-list mt-2">
								<li><a class="icon-phone" href="tel:+74993460108">+7 499 346 01 08</a></li>
								<li><a class="icon-mail" href="mailto:HotelReception@skolkovo.ru">HotelReception@skolkovo.ru</a></li>
							</ul>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-md-4">
							<strong>Отдел бронирования</strong>
						</div>
						<div class="col-12 col-md-8">
							<ul class="list-unstyled properties-list mt-2">
								<li><a class="icon-phone" href="tel:+74993460108">+7 499 346 01 08</a></li>
								<li><a class="icon-mail" href="mailto:HotelReservation@skolkovo.ru">HotelReservation@skolkovo.ru</a></li>
							</ul>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-md-4">
							<strong>Отдел продаж</strong>
						</div>
						<div class="col-12 col-md-8">
							<ul class="list-unstyled properties-list mt-2">
								<li><a class="icon-phone" href="tel:+74955393003">+7 495 539 30 03</a></li>
								<li><a class="icon-mail" href="mailto:event_sales@skolkovo.ru">event_sales@skolkovo.ru</a></li>
								<li><a class="icon-www" href="https://hotel.skolkovo.ru">hotel.skolkovo.ru</a></li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<!--
			<div class="panel_header border-bottom mt-5">
				<h2>Как доехать на автомобиле</h2>
			</div>
			 -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'PanelContacts',

};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-contacts";
</style>
